import PropTypes from 'prop-types';
import { SiKofi } from 'react-icons/si';
import './KofiButton.css';

const KofiButton = ({ 
  username = 'jooovi',
  buttonText = 'Apoiar no Ko-fi',
  backgroundColor = '#4f5b3e',
  textColor = '#f0eadb'
}) => {
  return (
    <a
      className="kofi-support"
      href={`https://ko-fi.com/${encodeURIComponent(username)}`}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={`${buttonText} (abre em nova aba)`}
      title={`${buttonText} (abre em nova aba)`}
      style={{ backgroundColor, color: textColor }}
    >
      <SiKofi className="kofi-support__icon" aria-hidden="true" />
      <span className="kofi-support__label">{buttonText}</span>
    </a>
  );
};

KofiButton.propTypes = {
  username: PropTypes.string,
  buttonText: PropTypes.string,
  backgroundColor: PropTypes.string,
  textColor: PropTypes.string
};

export default KofiButton;
